/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { IUser } from "@/interfaces/user/IUser";
import axios from "axios";

const axiosInstance = axios.create({
    headers: {
        "Access-Control-Allow-Origin": "*"
    }
});

export const user = {
    state: {
        user: {},
        institutionId: "",
        isLogged: false,
        ma: 0,
        logo: null
    },
    mutations: {
        SET_USER(state: IState, payload: IUser) {
            state.user = payload;
            state.institutionId = payload.institutionId;
        },
        SET_LOGGED(state: IState, payload: any) {
            state.isLogged = payload;
        },
        SET_MA(state: IState, payload: any) {
            state.ma = payload;
        },
        SET_LOGO(state: IState, payload: any) {
            state.logo = payload;
        }
    },
    actions: {
        async setEvaluation(context: any, payload: any) {
            return  await axios
                 .get(`${axios.defaults.baseURL}/evaluation?idInstitucion=${payload.idInstitucion}&idMedicionAsignada=${payload.idMedicionAsignada}&idPeriodo=${payload.idPeriodo}&idPersona=${payload.idPersona}`)
                 .then(res => {
                     context.commit("SET_EVALUATION", res.data);
                     return res;
                 })
                 .catch(error => {
                     context.commit("SET_ERROR", 404);
                     return error.response;
                 });
         },
        async actionSetUser(context: any) {
          return  await axios
                .get(`${axios.defaults.baseURL}/user/getData`)
                .then(res => {
                    context.commit("SET_USER", res.data);
                    context.commit("SET_MA", res.data.idMedicionAsignada)
                    context.commit("SET_LOGGED", true);
                    return res;
                })
                .catch(error => {
                    console.info("error cargando usuario", error);
                    return error;
                });
        },
        async resetUser(context: any) {
            await axios
                .get(`${axios.defaults.baseURL}/user/logout`)
                .then(res => {
                    console.log(res);
                    
                    const user = {};
                    context.commit("SET_USER", user)
                    context.commit("SET_LOGGED", false)
                    context.commit("SET_MA", 0)
                    context.commit("SET_LOGO", null)
                    console.info("Usuario logout Exitoso");

                })
                .catch(error => {
                    context.commit("SET_IS_LOGGED", false);
                    console.info("Error cleaning user", error);
                });
        },
        setUserLocal(context: any, payload: any) {
            context.commit("SET_USER", payload);
        },
        setLogged(context: any, payload: any) {
           context.commit("SET_LOGGED", payload);
        },
        setMa(context: any, payload: any) {
            context.commit("SET_MA", payload)
        },
        async setLogo(context: any, payload: any) {
            const url = `https://plataforma.romacl.com/LogoInstitucion?id=${payload}`;
           return await axios.get(url)
               .then(response=> {
                   console.log(response);
                   if (response) {
                       return url;
                   }
                   return null;
            })
        },
        setterLogo(context: any, payload: any) {
            context.commit("SET_LOGO", payload);
        }
    },
    getters: {
        // Get all User
        getUserData(state: IState) {
            return state.user;
        },
        getInstitutionId(state: IState) {
            return state.institutionId;
        },
        getLogged(state: IState) {
            return state.isLogged;
        },
        getMaUser(state: IState) {
            return state.ma;
        },
        getLogo(state: IState) {
            return state.logo;
        }
    }
};
